/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PatchDocument,
  PersonDTO,
  ReferencedPersonNameDTO,
} from '../models/index';
import {
    PatchDocumentFromJSON,
    PatchDocumentToJSON,
    PersonDTOFromJSON,
    PersonDTOToJSON,
    ReferencedPersonNameDTOFromJSON,
    ReferencedPersonNameDTOToJSON,
} from '../models/index';

export interface CreatePersonRequest {
    personDTO: PersonDTO;
}

export interface DeletePersonRequest {
    personId: number;
}

export interface GetExclusiveWorksOfPersonRequest {
    personId: number;
}

export interface GetOrganisationsOfPersonRequest {
    personId: number;
}

export interface GetPersonRequest {
    personId: number;
}

export interface GetPersonIdRequest {
    email: string;
}

export interface GetPersonNameByIdRequest {
    personId: number;
    nameId: number;
}

export interface GetPersonNamesRequest {
    personId: number;
}

export interface GetProjectsOfPersonRequest {
    personId: number;
}

export interface GetWorksByPersonNameRequest {
    nameId: number;
}

export interface GetWorksOfPersonRequest {
    personId: number;
}

export interface UpdatePersonRequest {
    personId: number;
    patchDocument: Array<PatchDocument>;
}

/**
 * 
 */
export class PersonApi extends runtime.BaseAPI {

    /**
     * Creates request options for createPerson without sending the request
     */
    async createPersonRequestOpts(requestParameters: CreatePersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personDTO'] == null) {
            throw new runtime.RequiredError(
                'personDTO',
                'Required parameter "personDTO" was null or undefined when calling createPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PersonDTOToJSON(requestParameters['personDTO']),
        };
    }

    /**
     */
    async createPersonRaw(requestParameters: CreatePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonDTO>> {
        const requestOptions = await this.createPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonDTOFromJSON(jsonValue));
    }

    /**
     */
    async createPerson(requestParameters: CreatePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonDTO> {
        const response = await this.createPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deletePerson without sending the request
     */
    async deletePersonRequestOpts(requestParameters: DeletePersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling deletePerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deletePersonRaw(requestParameters: DeletePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deletePersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePerson(requestParameters: DeletePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePersonRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getExclusiveWorksOfPerson without sending the request
     */
    async getExclusiveWorksOfPersonRequestOpts(requestParameters: GetExclusiveWorksOfPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getExclusiveWorksOfPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}/exclusiveWorks`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getExclusiveWorksOfPersonRaw(requestParameters: GetExclusiveWorksOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getExclusiveWorksOfPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getExclusiveWorksOfPerson(requestParameters: GetExclusiveWorksOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getExclusiveWorksOfPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getOrganisationsOfPerson without sending the request
     */
    async getOrganisationsOfPersonRequestOpts(requestParameters: GetOrganisationsOfPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getOrganisationsOfPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}/organisations`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getOrganisationsOfPersonRaw(requestParameters: GetOrganisationsOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getOrganisationsOfPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getOrganisationsOfPerson(requestParameters: GetOrganisationsOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getOrganisationsOfPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPerson without sending the request
     */
    async getPersonRequestOpts(requestParameters: GetPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPersonRaw(requestParameters: GetPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonDTO>> {
        const requestOptions = await this.getPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPerson(requestParameters: GetPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonDTO> {
        const response = await this.getPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPersonId without sending the request
     */
    async getPersonIdRequestOpts(requestParameters: GetPersonIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getPersonId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/id`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPersonIdRaw(requestParameters: GetPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const requestOptions = await this.getPersonIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getPersonId(requestParameters: GetPersonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getPersonIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPersonNameById without sending the request
     */
    async getPersonNameByIdRequestOpts(requestParameters: GetPersonNameByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPersonNameById().'
            );
        }

        if (requestParameters['nameId'] == null) {
            throw new runtime.RequiredError(
                'nameId',
                'Required parameter "nameId" was null or undefined when calling getPersonNameById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}/name/{nameId}`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));
        urlPath = urlPath.replace(`{${"nameId"}}`, encodeURIComponent(String(requestParameters['nameId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPersonNameByIdRaw(requestParameters: GetPersonNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferencedPersonNameDTO>> {
        const requestOptions = await this.getPersonNameByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferencedPersonNameDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPersonNameById(requestParameters: GetPersonNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferencedPersonNameDTO> {
        const response = await this.getPersonNameByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPersonNames without sending the request
     */
    async getPersonNamesRequestOpts(requestParameters: GetPersonNamesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPersonNames().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}/name`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPersonNamesRaw(requestParameters: GetPersonNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferencedPersonNameDTO>>> {
        const requestOptions = await this.getPersonNamesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferencedPersonNameDTOFromJSON));
    }

    /**
     */
    async getPersonNames(requestParameters: GetPersonNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferencedPersonNameDTO>> {
        const response = await this.getPersonNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProjectsOfPerson without sending the request
     */
    async getProjectsOfPersonRequestOpts(requestParameters: GetProjectsOfPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getProjectsOfPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}/projects`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProjectsOfPersonRaw(requestParameters: GetProjectsOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getProjectsOfPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getProjectsOfPerson(requestParameters: GetProjectsOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getProjectsOfPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWorksByPersonName without sending the request
     */
    async getWorksByPersonNameRequestOpts(requestParameters: GetWorksByPersonNameRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nameId'] == null) {
            throw new runtime.RequiredError(
                'nameId',
                'Required parameter "nameId" was null or undefined when calling getWorksByPersonName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/name/{nameId}/works`;
        urlPath = urlPath.replace(`{${"nameId"}}`, encodeURIComponent(String(requestParameters['nameId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorksByPersonNameRaw(requestParameters: GetWorksByPersonNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getWorksByPersonNameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getWorksByPersonName(requestParameters: GetWorksByPersonNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getWorksByPersonNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getWorksOfPerson without sending the request
     */
    async getWorksOfPersonRequestOpts(requestParameters: GetWorksOfPersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getWorksOfPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}/works`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getWorksOfPersonRaw(requestParameters: GetWorksOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getWorksOfPersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getWorksOfPerson(requestParameters: GetWorksOfPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getWorksOfPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePerson without sending the request
     */
    async updatePersonRequestOpts(requestParameters: UpdatePersonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updatePerson().'
            );
        }

        if (requestParameters['patchDocument'] == null) {
            throw new runtime.RequiredError(
                'patchDocument',
                'Required parameter "patchDocument" was null or undefined when calling updatePerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/person/{personId}`;
        urlPath = urlPath.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchDocument']!.map(PatchDocumentToJSON),
        };
    }

    /**
     */
    async updatePersonRaw(requestParameters: UpdatePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonDTO>> {
        const requestOptions = await this.updatePersonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonDTOFromJSON(jsonValue));
    }

    /**
     */
    async updatePerson(requestParameters: UpdatePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonDTO> {
        const response = await this.updatePersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
